import $ from 'jquery'
import select2 from 'select2'
import mask from 'jquery-mask-plugin'


export const fields = {
    data(){
        return {}
    },
    computed: {
        local_config(){
            return this.$store.state.stages[this.$store.state.active_view]
        },


        // helpers, readonly
        doe_date_of_birth:{
            set(val){
                this.$store.commit('update_field',{key:'doe_date_of_birth',data: val})
            },
            get(){
                return this.$store.state.fields_values.doe_date_of_birth
            }
        },
        dob() {
            return this.yy + '-' + this.mm  + '-' + this.dd;
        },
        mm: {
            set(val){
                this.$store.commit('update_field',{key:'mm',data: val})
            },
            get(){
                return this.$store.state.fields_values.mm
            }
        },
        dd: {
            set(val){
                this.$store.commit('update_field',{key:'dd',data: val})
            },
            get(){
                return this.$store.state.fields_values.dd
            }
        },
        yy: {
            set(val){
                this.$store.commit('update_field',{key:'yy',data: val})
            },
            get(){
                return this.$store.state.fields_values.yy
            }
        },

        // to save in store
        date_of_birth: {
            set(val){
                this.$store.commit('update_field',{key:'date_of_birth',data: val})
            },
            get(){
                return this.$store.state.fields_values.date_of_birth
            }
        },
        state: {
            set(val){
                this.$store.commit('update_field',{key:'state',data: val})
            },
            get(){
                return this.$store.state.fields_values.state
            }
        },
        first_name: {
            set(val){
                this.$store.commit('update_field',{key:'first_name',data: val})
            },
            get(){
                return this.$store.state.fields_values.first_name
            }
        },
        last_name: {
            set(val){
                this.$store.commit('update_field',{key:'last_name',data: val})
            },
            get(){
                return this.$store.state.fields_values.last_name
            }
        },
        email: {
            set(val){
                this.$store.commit('update_field',{key:'email',data: val})
            },
            get(){
                return this.$store.state.fields_values.email
            }
        },
        phone: {
            set(val){
                this.$store.commit('update_field',{key:'phone',data: val})
            },
            get(){
                return this.$store.state.fields_values.phone
            }
        },
        tc_accepted: {
            set(val){
                val = val === true ? 1:'';
                this.$store.commit('update_field',{key:'tc_accepted',data: val})
            },
            get(){
                return this.$store.state.fields_values.tc_accepted
            }
        },
        age_confirmed: {
            set(val){
                val = val === true ? 1:'';
                this.$store.commit('update_field',{key:'age_confirmed',data: val})
            },
            get(){
                return this.$store.state.fields_values.age_confirmed
            }
        },
        privacy_policies_accepted: {
            set(val){
                val = val === true ? 1:'';
                this.$store.commit('update_field',{key:'privacy_policies_accepted',data: val})
            },
            get(){
                return this.$store.state.fields_values.privacy_policies_accepted
            }
        },
        email_optin: {
            set(val){
                val = val === true ? 1:'';
                this.$store.commit('update_field',{key:'email_optin',data: val})
            },
            get(){
                return this.$store.state.fields_values.email_optin
            }
        },
        sms_optin: {
            set(val){
                val = val === true ? 1:'';
                this.$store.commit('update_field',{key:'sms_optin',data: val})
            },
            get(){
                return this.$store.state.fields_values.sms_optin
            }
        },
        address1: {
            set(val){
                this.$store.commit('update_field',{key:'address1',data: val})
            },
            get(){
                return this.$store.state.fields_values.address1
            }
        },
        address2: {
            set(val){
                this.$store.commit('update_field',{key:'address2',data: val})
            },
            get(){
                return this.$store.state.fields_values.address2
            }
        },
        city: {
            set(val){
                this.$store.commit('update_field',{key:'city',data: val})
            },
            get(){
                return this.$store.state.fields_values.city
            }
        },
        zipcode: {
            set(val){
                this.$store.commit('update_field',{key:'zipcode',data: val})
            },
            get(){
                return this.$store.state.fields_values.zipcode
            }
        },
        country: {
            set(val){
                this.$store.commit('update_field',{key:'country',data: val})
            },
            get(){
                return this.$store.state.fields_values.country
            }
        },
        uuid: {
            set(val){
                this.$store.commit('update_field',{key:'uuid',data: val})
            },
            get(){
                return this.$store.state.fields_values.uuid
            }
        },
        uid: {
            set(val){
                this.$store.commit('update_field',{key:'uid',data: val})
            },
            get(){
                return this.$store.state.fields_values.uid
            }
        },
        reward_reservation_uid: {
            set(val){
                this.$store.commit('update_field',{key:'reward_reservation_uid',data: val})
            },
            get(){
                return this.$store.state.fields_values.reward_reservation_uid
            }
        },
        // DOE only
        phone_daytime: {
            set(val){
                this.$store.commit('update_field',{key:'phone_daytime',data: val})
            },
            get(){
                return this.$store.state.fields_values.phone_daytime
            }
        },
        phone_evening: {
            set(val){
                this.$store.commit('update_field',{key:'phone_evening',data: val})
            },
            get(){
                return this.$store.state.fields_values.phone_evening
            }
        },

    },
    watch: {
        dob: {
            handler(){
                this.date_of_birth = this.dob
            },
            deep: true
        },
    },
    created(){

    },
    mounted() {

    }
}